import { Box, Theme } from '@mui/material';
import { SxProps } from '@mui/system';
import { CompanyBenefitSettings, EmployeeBenefitSettings } from '@pxtra-client-lib-legacy/gen';
import { FC } from 'react';
import {
  BavIcon,
  BkvIcon,
  BetreuungskostenIcon,
  ErholungsbeihilfeIcon,
  EssenzuschussIcon,
  FahrtkostenIcon,
  FolderIcon,
  InternetpauschaleIcon,
  JobbikeIcon,
  MppIcon,
  SachbezugIcon,
  TelefonkostenIcon,
  ÖpnvIcon
} from '../../../../icons';
import { IconProps } from '../../../../icons/templates/icon';

export type BenefitKey =
  | keyof Omit<CompanyBenefitSettings, 'custom'>
  | keyof EmployeeBenefitSettings;

export type BenefitIconKey = BenefitKey | 'other';

const benefitIconMap: Record<BenefitIconKey, FC<IconProps>> = {
  betreuungskosten: BetreuungskostenIcon,
  erholungsbeihilfe: ErholungsbeihilfeIcon,
  essenszuschuss: EssenzuschussIcon,
  fahrtkosten: FahrtkostenIcon,
  internetpauschale: InternetpauschaleIcon,
  telefonkosten: TelefonkostenIcon,
  öpnv_tickets: ÖpnvIcon,
  sachbezug: SachbezugIcon,
  jobbike: JobbikeIcon,
  bav: BavIcon,
  bkv: BkvIcon,
  mpp: MppIcon,
  other: FolderIcon
};

const getBenefitIcon = (benefitKey: BenefitIconKey, color: string, size: number) => {
  const Component = benefitKey in benefitIconMap ? benefitIconMap[benefitKey] : FolderIcon;

  let padding = 0;
  if (benefitKey === 'other') {
    size = size * 0.8;
    padding = size * 0.015;
  }
  return <Component color={color} height={size} width={size} sx={{ padding: padding }} />;
};

interface Props {
  benefitKey: BenefitIconKey;
  sx?: SxProps<Theme>;
  size?: number;
  backgroundColor?: string;
  color?: string;
}

export const BenefitIcon: FC<Props> = ({ benefitKey, size, backgroundColor, color, sx }) => {
  size = size ?? 40;
  color = color ?? 'white';
  backgroundColor = backgroundColor ?? 'heaven.main';

  return (
    <Box
      sx={{
        backgroundColor: backgroundColor,
        borderRadius: `${size * 0.35}px`,
        ...sx,
        height: size,
        width: size
      }}
    >
      {getBenefitIcon(benefitKey, color, size)}
    </Box>
  );
};
